import {ContactSelector} from "../Components/ContactSelector.tsx";
import {Contact} from "../Components/BaseTypes.ts";
import Select from "../Components/Select.tsx";
import {useMemo, useState} from "react";
import mediumSelect2Styles from "../Components/mediumSelect2Styles.ts";
import * as React from "react";

interface ReasonForIssue {
    pkReasonid: number,
    reaCode: string,
    reaDesc: string
}

export interface ContactSelectionProps {
    contactList: Contact[]
    selectedContactIds: number[],
    selectedReasonsForIssue: number[],
    selectedCustomEmailRecipients: string[],
    reasonsForIssueLookup: Record<number, ReasonForIssue>,
    currentClientId: number
}

function getRowIds(contactIds) {
    const rowIds = [];
    for (let i = 0; i < contactIds.length; i ++) {
        rowIds.push(Math.floor(Math.random() * 100000000));
    }
    return rowIds;
}

export default function TransmittalContactSelection(props: ContactSelectionProps) {
    const [selectedCustomEmailRecipients, setSelectedCustomEmailRecipients] = useState(props.selectedCustomEmailRecipients || []);
    const [selectedContactIds, setSelectedContactIds] = useState(props.selectedContactIds || []);
    const initRowIds = useMemo(() => getRowIds(props.selectedContactIds), []);
    const [rowIds, setRowIds] = useState(initRowIds);

    console.log('re render transmittal contact selection');

    const reasonOptionFromReason = (reason: ReasonForIssue) => {
        if (!reason) return null;
        return {
            label: `${reason.reaCode} - ${reason.reaDesc}`,
            value: reason.pkReasonid
        }
    }


    return (
        <>
            <h4 style={{
                margin: '5px 0 0 0',
                paddingLeft: '0.5em',
                lineHeight: '2.2em',
                backgroundColor: '#EEEEEE'
            }}>Recipients</h4>
            <table className='styled'>
                <tbody>
                <tr>
                    <th>Recipient</th>
                    <th>Company</th>
                    <th>Email</th>
                    <th>Reason For Issue</th>
                    <th className='p-0'>
                        <a
                            title="Add Recipient"
                            onClick={() => {
                                rowIds.push(Math.floor(Math.random() * 100000000));

                                setRowIds([...rowIds]);
                                //@ts-expect-error Function defined as html include
                                handleChangeEvent();
                            }}
                            className="js-add_collection_entry">
                            +
                        </a>
                    </th>
                </tr>

                {rowIds.map((rowId, index) => {
                        const contactId = selectedContactIds?.[index];
                        let companyName = '';
                        let email = '';
                        if (contactId === 0) {
                            companyName = '';
                            email = selectedCustomEmailRecipients?.[index];
                        } else {
                            const contact: Contact = props.contactList.find(contact => contact.pkContactid === contactId);
                            companyName = contact?.client?.cliCompanyname || contact?.supplier?.supCompanyname;
                            email = contact?.conEmail;
                        }

                        return <tr key={rowId}>
                            <td>
                                <ContactSelector
                                    onChange={(e) => {
                                        selectedContactIds[index] = e.value;
                                        setSelectedContactIds([...selectedContactIds]);
                                        //@ts-expect-error Function defined as html include
                                        handleChangeEvent();
                                    }}
                                    name={`trans_conClient[${index}]`}
                                    contactList={props.contactList}
                                    currentClientId={props.currentClientId}
                                    contactIdsToExclude={selectedContactIds}
                                    selectedContactId={contactId}
                                />
                            </td>
                            <td>
                                {companyName}
                            </td>
                            <td>
                                {contactId ? email : '' }
                                <input className='form-control' name={`custom_recipient_list[${index}]`} type={contactId === 0 ? 'email' : 'hidden'} value={contactId === 0 ? email : ''}
                                       onChange={(e) => {
                                           selectedCustomEmailRecipients[index] = e.target.value;
                                           setSelectedCustomEmailRecipients([...selectedCustomEmailRecipients]);
                                       }}
                                />
                            </td>
                            <td>

                                {/*{console.log(reasonOptionFromReason(props.reasonsForIssueLookup?.[props.selectedReasonsForIssue[index]])) && ''}*/}
                                <Select
                                    name={`clireasonID[${index}]`}
                                    onChange={() => {
                                        //@ts-expect-error Function defined as html include
                                        handleChangeEvent();
                                    }}
                                    styles={mediumSelect2Styles('25em')}
                                    required={true}
                                    placeholder='Select Reason For Issue'
                                    options={Object.values(props.reasonsForIssueLookup).map(reason => reasonOptionFromReason(reason))}
                                    defaultValue={reasonOptionFromReason(props.reasonsForIssueLookup?.[props.selectedReasonsForIssue[index]])}
                                    // defaultValue={}

                                />
                            </td>
                            <td className='p-0'>
                                <a style={{backgroundColor: 'transparent'}}
                                   onClick={() => {
                                       selectedCustomEmailRecipients.splice(index, 1);
                                       selectedContactIds.splice(index, 1);
                                       // setSelectedContactIds(selectedContactIds.filter(a => a !== contactId))
                                       setRowIds(rowIds.filter(a => a !== rowIds[index]))
                                       //@ts-expect-error Function defined as html include
                                       handleChangeEvent();
                                   }}
                                   className='js-delete_collection_entry'>
                                    x
                                </a>
                            </td>
                        </tr>
                    }
                )}
                </tbody>
            </table>
        </>
    )
}